import React from "react";
import * as dayjs from "dayjs";
import IntlMessages from "util/IntlMessages";
import { Button } from "@material-ui/core";
import Table, { getTextLabels } from "components/Form/Table";
import CardBox from "components/CardBox/index";

const LedagaTable = ({
  data,
  handleOpenCRU,
  setCurrentRowObj,
  readOnly,
  handleOpenDel,
  lesionSideList,
  locationLesionsList,
  amountMedicationList
}) => {
  const options = {
    filter: false,
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    search: false,
    textLabels: getTextLabels(),
  };

  const handleClick = (obj) => {
    handleOpenCRU();
    setCurrentRowObj(!obj ? null : obj);
  };

  const getRowObj = (tableMeta) => tableMeta.tableData[tableMeta.rowIndex];

  const getNameById = (list, value) => {
    if (value === null || value === undefined) return "";
    const item = list.find(x => x.id === value);
    return item ? item.name : "";
  };

  const columns = [
    {
      name: "consultationDate",
      label: "Fecha consulta con el médico",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "mswat",
      label: "% MSWAT",
      options: { filter: false, sort: false },
    },
    {
      name: "lesionSide",
      label: "Costado de la localización de las lesiones",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => getNameById(lesionSideList, value),
      },
    },
    {
      name: "lesionLocation",
      label: "Localización de las lesiones",
      options: { filter: false, 
        sort: false,
        customBodyRender: (value) => getNameById(locationLesionsList, value),
      },
    },
    {
      name: "clormetina",
      label: "¿Se aplica clormetina en esta lesión?",
      options: {
        filter: false, sort: false,
        customBodyRender: (value) => (value ? "Sí" : "No"),
      },
    },
    {
      name: "lastApplicationDate",
      label: "Fecha última aplicación",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "tubeExpiredDate",
      label: "Fecha de vencimiento tubo",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "amount",
      label: "Cantidad de medicamento en stock Tubo/s - días",
      options: { filter: false, 
        sort: false,
        customBodyRender: (value) => getNameById(amountMedicationList, value),
      },
    },
    {
      name: "actions",
      label: <IntlMessages id="core.actions" />,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowObj = getRowObj(tableMeta);
          return (
            <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
              <Button
                onClick={() => handleClick(rowObj)}
                variant="contained"
                className="jr-btn jr-btn-xs"
              >
                <i className="zmdi zmdi-edit"></i>
              </Button>
              <Button
                onClick={() => {
                  setCurrentRowObj(rowObj);
                  handleOpenDel();
                }}
                variant="contained"
                className="jr-btn jr-btn-xs"
              >
                <i className="zmdi zmdi-delete"></i>
              </Button>
            </div>
          );
        },
      },
    },
  ];

  return (
    <div className="row">
      <CardBox styleName="col-12" cardStyle="p-0 border-dialog-card">
        <Table
          className="border-dialog-card"
          data={data}
          columns={columns}
          options={options}
        />
      </CardBox>
      {!readOnly && (
        <div className="col-lg-12 col-md-12 col-xs-12 mt-4 text-center">
          <Button
            onClick={() => handleClick(null)}
            variant="contained"
            color="primary"
          >
            <IntlMessages id="core.add" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default LedagaTable;
